<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10Fjjqh/images/cover.jpg?1708648506520" alt="This image is the cover for the book Your Blueprint for Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Your Blueprint for Life
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Your Blueprint for Life</i></b><b> gives the strategies readers need to align their passions, gifts, and calling.</b></p><p>As CEO of the Blueprint for Life ministry, Michael Kendrick is devoted to helping others discover God’s purpose for their lives. <i>Your Blueprint for Life </i>guides readers toward a Christ-honoring life—one that brings joy spiritually, financially, relationally, physically, and professionally. With practical guidance for discovering passion, gifts, and callings, <i>Your</i><i>Blueprint for Life</i> gives readers concrete strategies for achieving the life they were created to lead, such as:</p>Intentionally carve out a specific time each day to hear from GodPrune your relational portfolioStep into your children’s worldRemember you are a steward of God’s resources, not an owner of your resources<p>For anyone who has ever wondered why they were put on earth, <i>Your</i><i>Blueprint for Life</i> not only answers the question, but it also gives readers a solid guide to understanding and achieving God’s vision for their lives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Kendrick
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60548406